import {Api} from '../../../Api.js'

const RESOURCE = 'shipping'

export default {
    resource: RESOURCE,
    prefix: 'shop/',
    all(query) {
        return Api().get(this.prefix + this.resource + '/all'  + (query ? query : '') )
    },
    query(query) {
        return Api().get(this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.prefix + this.resource, data)
    },
    update(id, data) {
        return Api().put(this.prefix + this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.prefix + this.resource + '/' + id)
    },
    duplicate(id) {
        return Api().get(this.prefix + this.resource + '/duplicate/' + id)
    },
    check(data) {
        return Api().post(this.prefix + this.resource + '/check', data)
    },
}


// WEBPACK FOOTER //
// ./src/modules/shop/shipping/ShippingService.js